<template>
	<div>
   <!-- 404 Error Text -->
   <div class="text-center">
     <div class="error mx-auto" data-text="404">404</div>
     <p class="lead text-gray-800 mb-5">Page Not Found</p>
     <p class="text-gray-500 mb-0">Halaman yang anda cari tidak ditemukan</p>
     <RouterLink to="/">&larr; Kembali ke Dashboard</RouterLink>
   </div>
 </div>
</template>

<script>
export default {
  // mounted () {
  //   setTimeout(() => {
  //     console.log(this.$route)
  //     this.$router.replace('/')
  //   }, 1000)
  // }
}
</script>